import { Duration, DateTime } from "luxon";

export default {
  formatTimeStr(time) {
    return time
      .substr(0, 12)
      .substr(3)
      .padEnd(9, ".000");
  },

  timeStrFromSecs(secs) {
    const mins = Math.floor(secs / 60);
    const s = secs % 60;
    return `${mins.toString().padStart(2, 0)}:${s
      .toFixed(3)
      .toString()
      .padStart(6, 0)}`;
  },
  timeStrFromSecsStr(secs) {
    return this.timeStrFromSecs(parseFloat(secs));
  },
  dateStrToLocale(str) {
    return new Date(str).toLocaleString();
  },
  strToDateLocale(str) {
    return new DateTime.fromISO(str).toLocaleString(DateTime.DATE_MED);
  },
  strToWeekdayLocale(str) {
    return new DateTime.fromISO(str).toFormat("EEE");
  },
  strToTimeLocale(str) {
    return new DateTime.fromISO(str).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
  },
  /**
   * @param {number} secs
   * @returns {string}
   */
  longDurationStrFromSecs(secs) {
    return Duration.fromMillis(secs * 1000).toFormat("d 'days' hh 'hrs' mm 'mins'");
  },
  /**
   * @param {number} secs
   * @returns {string}
   */
  durationStrFromSecs(secs) {
    return Duration.fromMillis(secs * 1000).toFormat("hh':'mm':'ss");
  },
  formatScore(score, type) {
    if (type == "CheckpointRun") return parseInt(score);
    return this.timeStrFromSecsStr(score);
  },
  whToCal(wh) {
    return wh * 3.9;
  },
  numberToStr(x, fractDigits) {
    return x.toLocaleString({}, { useGrouping: true, maximumFractionDigits: (fractDigits || 0) });
  },
};